import { render, staticRenderFns } from "./DetailsStockModal.vue?vue&type=template&id=45e0fa2f&scoped=true"
import script from "./DetailsStockModal.vue?vue&type=script&lang=js"
export * from "./DetailsStockModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e0fa2f",
  null
  
)

export default component.exports